export const enrollProps = {
  dataAnalytics: 'syllabus',
  lastPrimarySource: 'syllabus'
};

export const getNoFiltersKey = (topicUID) =>
  `${topicUID}-status-all-type-all-language-all`;
